// Deliver optimized, appropriately-sized images.
// For Cloudinary-hosted URLs, inject f_auto,q_auto + resize transforms.
// For any other URL (local /img, external), return unchanged.
export function optimg(url, { w, h, q = "auto", crop = "fill" } = {}) {
  if (!url || typeof url !== "string") return url;
  if (!url.includes("res.cloudinary.com") || !url.includes("/upload/")) return url;
  if (/\/upload\/(f_auto|q_auto|w_|h_|c_)/.test(url)) return url; // already transformed
  const t = ["f_auto", `q_${q}`];
  if (w || h) t.push(`c_${crop}`, "g_auto");
  if (w) t.push(`w_${w}`);
  if (h) t.push(`h_${h}`);
  return url.replace("/upload/", `/upload/${t.join(",")}/`);
}
